<div class="width100" (click)="focus()">
  <mat-form-field >
  <input #textbox (focus)="focus()"  matInput type="number" [(ngModel)]="data.currentVal">
  <mat-hint align="end">Please enter a number</mat-hint>
</mat-form-field>

</div>
<p class="summary2" *ngIf="undefined != getYesterday()">{{getYesterday()}} {{getYesterdayText()}}. </p>
<p class="summary2" *ngIf="undefined === getYesterday()">Did not log {{data.getName()}} {{getYesterdayText()}}. </p>
